import { useCallback, useContext, useEffect, useMemo } from 'react';
import { generatePath } from 'react-router';

import useMultiSelect from 'src/hooks/useMultiSelect';
import { apiPaths } from 'src/services/api/apiPaths';
import { AccordionContext } from 'src/components/common/Accordion';
import { CREATE_FOLLOW_UP_MODAL_ACCORDION_NAMES } from 'src/components/myFollowUp/MyFollowUpPage/CreateMyFollowUpModal/constants';
import { useCreateActionItemContext } from 'src/components/myFollowUp/MyFollowUpPage/CreateMyFollowUpModal/CreateActionItemContext';

import { useOrgUnitBySurveyQuery } from './useOrgUnitBySurveyQuery';

const useSelectOrgUnit = () => {
  const { surveyId, selectedOrgUnits, orgTreeState, followUpActionModuleId } =
    useCreateActionItemContext();
  const { toggleActiveState } = useContext(AccordionContext);
  const { data } = useOrgUnitBySurveyQuery(surveyId, followUpActionModuleId);
  const ctrlDown = useMultiSelect();

  const generateFetchChildrenEndpoint = useCallback(
    (orgUnitId: number) =>
      surveyId
        ? `${generatePath(apiPaths.ORG_UNIT_CHILDREN_BY_SURVEY, {
            orgUnitId,
            surveyId,
          })}`
        : 'placeholder-will-never-be-called',
    [surveyId],
  );

  // open the next accordion item when an org unit is selected without ctrl key
  useEffect(() => {
    if (selectedOrgUnits.length > 0 && !ctrlDown) {
      toggleActiveState(CREATE_FOLLOW_UP_MODAL_ACCORDION_NAMES.OWNER);
    }
  }, [selectedOrgUnits, toggleActiveState, ctrlDown]);

  const selectedOrgUnitNames = useMemo(
    () => selectedOrgUnits.map((orgUnit) => orgUnit.name).join(', '),
    [selectedOrgUnits],
  );

  return {
    selectedOrgUnitNames,
    surveyId,
    orgTreeState,
    data,
    generateFetchChildrenEndpoint,
  };
};

export default useSelectOrgUnit;
